import styled from '@emotion/styled'

export const ScrollRevealItemStyled = styled.div`
  display: block;
  opacity: ${({ isRevealed }) => isRevealed ? '1' : '0'};
  transition: opacity .8s ease-out
`
